export default __webpack_public_path__ + "bar-graph-on-a-rectangle.png";